import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetReporteLogos, ReporteLogoDto } from '../../shared/interfaces/database/configuracion';

@Injectable({
  providedIn: 'root'
})
export class ReporteLogoService {

  private readonly baseUrl = `${environment.apiUrl}/api/reportes-logo`;

  constructor(private readonly http: HttpClient) { }

  public getReporteLogos(): Observable<IGetReporteLogos[]> {
    return this.http.get<IGetReporteLogos[]>(`${this.baseUrl}`);
  }

  public crearReporteLogo(request: ReporteLogoDto, archivo: File): Observable<void> {
    const formData = new FormData();
    formData.append('archivo', archivo);
    formData.append('request', new Blob([JSON.stringify(request)], { type: 'application/json' }));
    return this.http.post<void>(`${this.baseUrl}`, formData);
  }

  public actualizarReporteLogo(id: number, request: ReporteLogoDto, archivo?: File): Observable<void> {
    const formData = new FormData();
    formData.append('request', new Blob([JSON.stringify(request)], { type: 'application/json' }));
    
    if (archivo) {
      formData.append('archivo', archivo);
    }
    
    return this.http.post<void>(`${this.baseUrl}/actualizar/${id}`, formData);
  }

  public eliminarReporteLogo(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  public descargarReportePrevisualizacion(id: number): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/previsualizar/${id}`, { responseType: 'blob' });
  }

}
